(() => {
  const script = document.currentScript;
  const sourceHost = script && script.dataset.storeDomain;
  const primaryOrigin = script && script.dataset.primaryOrigin;
  if (!sourceHost || !primaryOrigin) return;

  const rootSelector = '[id^="leeep-tag-"], [id^="leeep-embedded-"]';
  const embeddedLinkSelector = '[id^="leeep-tag-"] a[href], [id^="leeep-embedded-"] a[href]';

  function normalizeLink(link) {
    if (!link.matches('a[href]') || !link.closest(rootSelector)) return;

    try {
      const url = new URL(link.getAttribute('href'), document.baseURI);
      if (!['http:', 'https:'].includes(url.protocol)
        || (url.hostname !== sourceHost && url.origin !== primaryOrigin)
        || url.port || url.username || url.password) return;

      // LEEEPの旧リンク名と、Shopifyで公開中のページハンドルを揃える。
      if (url.pathname === '/pages/staff-ranking-detail') url.pathname = '/pages/staff-list-detail';

      // 詳細ID・絞り込み条件・ハッシュは保持し、LEEEP内の自ストアリンクだけを補正する。
      const href = primaryOrigin + url.pathname + url.search + url.hash;
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    } catch (error) {
      // URLとして解釈できない値は変更しない。
    }
  }

  function normalizeTree(node) {
    if (node.nodeType !== 1) return;
    normalizeLink(node);
    const selector = node.closest(rootSelector) ? 'a[href]' : embeddedLinkSelector;
    node.querySelectorAll(selector).forEach(normalizeLink);
  }

  function init() {
    normalizeTree(document.body);

    // 遅延描画・ページ送り・タグの再描画と、既存リンクのhref更新にも追従する。
    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') {
          if (record.attributeName === 'id') normalizeTree(record.target);
          else normalizeLink(record.target);
        } else {
          record.addedNodes.forEach(normalizeTree);
        }
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href', 'id']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
